export function isFormField(schema) {
  return Object.keys(schema).length === 0 || schema.hasOwnProperty("value") || schema.hasOwnProperty("validators");
}
export function isFormFieldArray(schema) {
  return Array.isArray(schema) && schema.every(isFormField);
}
export function isFormGroup(schema) {
  return !isFormField(schema);
}
export function isFormGroupArray(schema) {
  return Array.isArray(schema) && schema.every(isFormGroup);
}
